/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="common/smart-mover.models.ts"/>
///<reference path="data-templates/data-template-list.ts"/>
///<reference path="../../common/common.interface.ts"/>
///<reference path="../../busy/busy.interface.ts"/>

module Meevo.Components.Controls.SmartMover {
    'use strict';

    import Dictionary = _.Dictionary;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    class MeevoSmartMover implements IMeevoSmartMover {
        static $inject = [
            '$q',
            '$scope',
            '$translate',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            'meevo.components.common.SecurityService',
            'meevo.components.modal.ModalService',
            '$filter'
        ];

        private _hideMover: boolean;

        dataTemplate: IDataTemplate;

        //#regionBindings
        genericArrayList?: IListElement[];
        template: DataTemplateNames;
        criteria: ISmartMoverCriteria;
        model: Dictionary<any>;
        properties: string[];
        securityAccess?: SecurityAccessEnum;
        required?: boolean;
        blockOnFetch?: boolean;
        defaultValue: Dictionary<any>;
        removeAllOption: boolean;
        hideAllSelectedCheckbox?: boolean;
        unSelectAll: boolean;
        url?: string;
        defaultFilterValue?: any;
        onFilterChanged?: TFilterChangedFn;
        hiddenValue?: SmartMoverHiddenValue;
        onChangeCallback?(): Function;

        onCollectionFetched?(collection: ICollectionBase<any>): Function;

        updateCollectionUsingModel?: any;
        changeBusinessTypeId?(): any;

        updateIsAllSelectedInModel?: boolean;
        emptyMeansAll?: boolean;
        hideMoverAfterFetchIfHideSelectedInternal?: boolean;

        showTips: boolean;

        alwaysExcludeInactive: boolean;

        labelKeys?: IMoverLabelKeys;

        private _disabled?: boolean;
        get disabled() {
            return this._disabled;
        }

        set disabled(value: boolean) {
            this._disabled = value;
            if (this.collection) {
                this.collection.setDisabled(value);
            }
            if (this.dataTemplate) {
                this.dataTemplate.disabled = value;
            }
        }

        title: string;
        allSelected?: boolean;

        //#endregionBindings

        get collection(): ICollectionBase<any> {
            return this.dataTemplate ? this.dataTemplate.collection : null;
        }

        get valid(): boolean {
            return this.dataTemplate ? this.dataTemplate.valid : false;
        }

        get allSelectedClass(): CategoryCheckboxClassName {
            if (this.dataTemplate) {
                if (this.dataTemplate.collection.models.length === 0) {
                    return 'disabled';
                }

                if (this.dataTemplate.collection.selected) {
                    return 'checked';
                }

                if (this.dataTemplate.collection.selectedModelsLength > 0) {
                    return 'partial';
                }
            }

            return 'unchecked';
        }

        get securityCheckErrorMessage() {
            if (!(<ISecureDataTemplate>this.dataTemplate).securityErrorMessage) {
                return '';
            }

            return (<ISecureDataTemplate>this.dataTemplate).getSecurityErrorMessage(this.$translate, {
                loggedInUser: this.identityService.current().displayName
            });
        }

        get totalSelectedMessage(): string {
            if (!this.dataTemplate || !this.dataTemplate.totalSelectedMessage) {
                return '';
            }

            return this.dataTemplate.totalSelectedMessageModel.getText(this.$translate, this.dataTemplate.totalSelectedCount);
        }

        get totalSelectedMessageModel(): ISmartMoverTextBase {
            if (!this.dataTemplate || !this.dataTemplate.totalSelectedMessage) {
                return;
            }

            return this.dataTemplate.totalSelectedMessageModel;
        }

        get totalParentSelectedMessage(): string {
            if (!this.dataTemplate || !this.dataTemplate.totalParentSelectedMessage) {
                return '';
            }

            return this.dataTemplate.totalParentSelectedMessageModel.getText(this.$translate, this.dataTemplate.totalParentSelectedCount);
        }

        get totalParentSelectedMessageModel(): ISmartMoverTextBase {
            if (!this.dataTemplate || !this.dataTemplate.totalParentSelectedMessage) {
                return;
            }

            return this.dataTemplate.totalParentSelectedMessageModel;
        }

        get allSelectedLabel(): string {
            return this.dataTemplate ? this.dataTemplate.allSelectedLabel : '';
        }

        get allSelectedInternal(): boolean {
            return this.collection.selected;
        }

        set allSelectedInternal(value: boolean) {
            if (this.dataTemplate && this.dataTemplate.disabled) {
                return;
            }

            if (this.collection)
                this.collection.setSelectedValue(value);
        }

        get objectStateEnum() {
            return ObjectStateEnum;
        }

        get securityAccessEnum() {
            return SecurityAccessEnum;
        }

        get allSelectedSecurityKey() {
            return (<ISecureDataTemplate>this.dataTemplate).allSelectedSecurityKey;
        }

        get hideMover(): boolean {
            return (this.dataTemplate && this.dataTemplate.showAllSelected) && this._hideMover;
        }

        set hideMover(value: boolean) {
            this._hideMover = value;

            if (this.collection) {
                this.collection.setMoverVisibility(this.hideMover);
            }
            if (this != null && value) {
                this.allSelectedInternal = true;
            }
            this.allSelected = value;
            if (this.dataTemplate)
                this.dataTemplate.onHideToggle(value);
        }

        private _showMover: boolean;
        public get showMover() {
            return this._showMover && this.dataTemplate && this.dataTemplate.showMover;
        }

        public set showMover(value) {
            this._showMover = value;
        }

        constructor(private $q: ng.IQService,
                    private $scope: ng.IScope,
                    private $translate: ng.translate.ITranslateService,
                    private busyService: Meevo.Components.Busy.IBusyService,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private identityService: Meevo.Components.Common.IIdentityService,
                    private securityService: Meevo.Components.Common.ISecurityService,
                    private modalService: Meevo.Components.Modal.IModalService,
                    private $filter: ng.IFilterService) {
            if (!this.removeAllOption) {
                this._hideMover = true;
            }
        }

        setIsAllSelected(value: boolean) {
            this.model['isAllSelected'] = !value;
        }

        updateIsAllSelected(value: boolean) {
            if (this.updateIsAllSelectedInModel) {
                this.model['isAllSelected'] = value;
            }

            if (this.unSelectAll && !value) {
                this.allSelectedInternal = false;
            }
        }

        $onInit() {
            this.loadDataTemplate();
        }

        loadDataTemplate() {
            this.dataTemplate = null;
            const DataTemplate: IDataTemplateStatic = DataTemplates[this.template];

            if (angular.isUndefined(this.showTips)) {
                this.showTips = true;
            }

            if (angular.isUndefined(this.allSelected)) {
                this.allSelected = true;
            } else {
                this.hideMover = this.allSelected;
            }

            if (angular.isUndefined(this.defaultValue)) {
                this.defaultValue = {};
            }

            if (!DataTemplate) {
                this.$scope.$destroy();
                throw new Error(`Unknown template "${this.template}"`);
            }

            var businessTypeId: any;
            businessTypeId = Model.Guard.isSomething(this.changeBusinessTypeId)
                ? this.changeBusinessTypeId
                : this.identityService.businessTypeId;

            this.dataTemplate = new DataTemplate(this.model, this.properties, {
                    criteria: {
                        businessTypeList: [businessTypeId],
                        locationList: [this.identityService.locationId],
                        selectModelBy: null,
                        ...this.criteria
                },
                    dataService: this.dataService,
                    defaultValue: this.defaultValue,
                    loggedInUserId: this.identityService.current().userId.toString(),
                    required: this.required,
                    modalService: this.modalService,
                    $scope: this.$scope,
                    $filter: this.$filter,
                    inactiveLabel: this.$translate.instant("LABEL_MOVER_INACTIVE"),
                    url: this.url,
                    hiddenValue: this.hiddenValue,
                    $q: this.$q,
                    defaultFilterValue: this.defaultFilterValue,
                    alwaysExcludeInactive: this.alwaysExcludeInactive,
                    labelKeys: this.labelKeys,
                }, this.genericArrayList);
            this.title = this.title || this.dataTemplate.title;
            this.disabled = this.disabled || this.dataTemplate.disabled;

            if (this.dataTemplate && angular.isFunction(this.onChangeCallback)) {
                this.dataTemplate.onChangeCallback = this.onChangeCallback;
            }

            if (this.dataTemplate) {
                this.dataTemplate.setEvents(
                    this.onFilterChanged
                );

                this.dataTemplate.on(ON_FETCH_START, () => {
                    if (this.blockOnFetch) {
                        this.busyService.start();
                    }
                });

                this.dataTemplate.on(ON_FETCH_END, () => {
                    this.onCollectionUpdated();
                    // only set if select all checkbox is visibile.  otherwise, if hide b/c all are selected
                    // won't be able to access tree
                    if (this.dataTemplate && this.dataTemplate.showAllSelected && this.dataTemplate.model
                        && !this.dataTemplate.model.hideAllSelectedCheckbox
                        && this.hideMoverAfterFetchIfHideSelectedInternal) {
                        this.hideMover = this.allSelectedInternal;
                    }
                    this.showMover = true;
                    this.busyService.stop();

                    if (typeof this.onCollectionFetched === 'function') {
                        this.onCollectionFetched(this.dataTemplate.leafCollection);
                    }
                });

                this.dataTemplate.collection.on(MODEL_UPDATED_OUTSIDE, () => {
                    if (this.hideMover && this.allSelected == false) {
                        this.hideMover = false;
                    }
                });

                if (this.dataTemplate.hasSecurity) {
                    (<ISecureDataTemplate>this.dataTemplate).checkSecurityKey(this.securityService);
                }
            }

            if (this.dataTemplate && !(this.genericArrayList instanceof Array)) {
                (<ng.IPromise<any>>this.dataTemplate.fetch(this.dataService))
                    .then(() => {
                        this.onCollectionUpdated();
                        this.setWatchers();
                        this.showMover = true;
                    });

                this.$scope.$watch(() => this.criteria, _.debounce((newValue, oldValue) => {
                    if (!newValue || newValue === oldValue) return;

                    this.$scope.$apply(() => {
                        this.dataTemplate
                            .onCriteriaUpdate(newValue, this.$q)
                            .then(() => {
                                if (this.hideMover) {
                                    this.onCollectionUpdated();
                                }
                            });
                    });

                }, 500), true);
            } else {
                this.$scope.$watch(() => this.genericArrayList, (newValue) => {
                    if (!(newValue instanceof Array)) return;

                    this.collection.handleResponse(newValue);
                    this.onCollectionUpdated();
                    this.showMover = true;
                });
                this.setWatchers();
            }
        }

        private setWatchers() {
            // there are cases where the entire model can be overwritten without the directive being destroyed so need to update connected model of collection
            this.$scope.$watch(() => this.model,
                (newValue) => {
                    if (this.dataTemplate) {
                        this.dataTemplate.model = newValue;
                        this.dataTemplate.updateConnectedModels();

                        if (!!newValue) {
                            this.dataTemplate.reconnectLeafCollectionModel(newValue);
                            this.onCollectionUpdated();
                        }
                    }
                });
            this.$scope.$watch(() => this.required,
                (newValue: boolean) => {
                    if (this.dataTemplate) {
                        this.dataTemplate.required = newValue;
                    }
                }
            )
            this.$scope.$watch(() => this.allSelected,
                (newValue: boolean) => {
                    this.hideMover = newValue;
                });

            if (this.dataTemplate) {
                this.$scope.$watch(() => this.dataTemplate.allSelected, newValue => {
                    if (newValue != undefined)
                        this.allSelected = newValue;
                });

                this.dataTemplate.setWatchers(this.$scope);
            }

            if (this.removeAllOption) {
                this.allSelected = false;
                this._hideMover = false;
                if (this.dataTemplate) {
                    this.dataTemplate.showAllSelected = false;
                    this.dataTemplate.onHideToggle(false);
                    this.dataTemplate.updateCollectionFromModel();
                }
            }

            if (this.hideAllSelectedCheckbox) {
                this.dataTemplate.model.hideAllSelectedCheckbox = true;
            }
        }

        private onCollectionUpdated() {
            this.collection.setMoverVisibility(this.hideMover);

            if (this.dataTemplate && this.dataTemplate.leafCollection && !this.allSelected) {
                this.dataTemplate.leafCollection.updateCollectionFromModel(this.dataTemplate.leafCollection.connectedModel);
                this._hideMover = false;
            } else {
                // Any smart movers using updateCollectionUsingModel are being used in data maintenance forms which can be saved / loaded and the code below is used for properly loading a saved smart mover configuration
                if (this.updateCollectionUsingModel && this.model != null && this.properties[0] != null && this.model[this.properties[0]] != null && this.hideMover == false) {
                    if (this.model[this.properties[0]].length == 0 && this.emptyMeansAll) {
                        this.collection.setSelectedValue(true);
                        this._hideMover = true;
                    }
                    else {
                        for (var i = 0; i < this.collection.models.length; i++) {
                            var isSelected = false
                            for (var j = 0; j < this.model[this.properties[0]].length; j++) {
                                if (this.collection.models[i].id == this.model[this.properties[0]][j]) {
                                    isSelected = true;
                                    break;
                                }
                            }
                            this.collection.models[i].selected = isSelected;
                            if (this.properties.length >= 2 && this.properties[1] != null && this.model[this.properties[1]] != null && this.collection.models[i]['models'] != null) {
                                for (var j = 0; j < this.collection.models[i]["models"].length; j++) {
                                    var isInnerSelected = false;
                                    for (var k = 0; k < this.model[this.properties[1]].length; k++) {
                                        if (this.collection.models[i]['models'][j] != null && this.collection.models[i]['models'][j].id == this.model[this.properties[1]][k]) {
                                            isInnerSelected = true;
                                            break;
                                        }
                                    }
                                    this.collection.models[i]['models'][j].selected = isInnerSelected;
                                }
                            }
                        }
                    }
                } else if (this.hideMover) {
                    this.collection.setSelectedValue(true);
                }
                this.hideMover = this._hideMover;
            }

            this.collection.setDisabled(this.disabled);
        }
    }

    angular.module('meevo.components.controls.SmartMover')
        .component('meevoSmartMover', {
            templateUrl: 'app/components/controls/smart-mover/smart-mover.html',
            controllerAs: '$ctrl',
            transclude: {
                top: '?top'
            },
            bindings: {
                template: '@',
                url: '@?',
                hiddenValue: '=?',
                properties: '<',
                model: '=ngModel',
                securityAccess: '=?',
                criteria: '=?',
                genericArrayList: '=?',
                required: '=?ngRequired',
                defaultValue: '=?',
                blockOnFetch: '<?',
                disabled: '<?ngDisabled',
                title: '@',
                allSelected: '=?',
                unSelectAll: '<',
                removeAllOption: '=?',
                hideAllSelectedCheckbox: '=?',
                onChangeCallback: '=?',
                updateCollectionUsingModel: '=?',
                changeBusinessTypeId: '=?',
                showTips: '=?',
                onCollectionFetched: '=?',
                updateIsAllSelectedInModel: '=?',
                emptyMeansAll: '=?',
                hideMoverAfterFetchIfHideSelectedInternal: '=?',
                defaultFilterValue: '=?',
                onFilterChanged: '&?',
                alwaysExcludeInactive: '=?',
                labelKeys: '=?',
            },
            controller: MeevoSmartMover
        });

}
